import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getProductsSortingOptions (categoryId, callback) {
    HTTP.get('sort/option?category_id=' + categoryId).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getProductsSortingList (params, callback) {
    if (params !== undefined) {
      HTTP.get('sort/products?category_id=' + params.categoryId + '&sort_option=' + params.sortOption + '&language=' + params.language).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  updateProductsSorting (params, callback) {
    if (params !== undefined) {
      HTTP.put('sort/products', params).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
        if (e.response.status === 400) {
          callback(e.response)
        }
      })
    }
  },
  updateProductsSortingBackend (params, callback) {
    if (params !== undefined) {
      HTTP.put('sort/backend/products', params).then(response => {
        if (response.status === 201) {
          callback(response)
        }
      }).catch(e => {
        console.log(e)
        if (e.response.status === 400) {
          callback(e.response)
        } else if (e.response.status === 401) {
          HttpFunctions.response401()
        } else if (e.response.status === 403) {
          console.log('Error: pdo error message')
        }
      })
    }
  },
  setProductSortingPin (params, callback) {
    if (params !== undefined) {
      HTTP.post('sort', params).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
        if (e.response.status === 400) {
          callback(e.response)
        }
      })
    }
  },
  deleteProductSortingPin (param, callback) {
    if (param !== undefined) {
      HTTP.delete('sort', { data: param }).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
        if (e.response.status === 400) {
          callback(e.response)
        }
      })
    }
  },
  setProductsSortOption (params, callback) {
    if (params !== undefined) {
      HTTP.put('sort/option', params).then(response => {
        if (response.status === 201 || response.status === 400) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  saveProductsSorting (params, callback) {
    if (params !== undefined) {
      HTTP.put('sort', params).then(response => {
        if (response.status === 201) {
          callback(response)
        }
      }).catch(e => {
        console.log(e)
        if (e.response.status === 400) {
          callback(e.response)
        } else if (e.response.status === 401) {
          HttpFunctions.response401()
        } else if (e.response.status === 403) {
          console.log('Error: pdo error message')
        }
      })
    }
  },
  updateProductsSortingByTarget (params, callback) {
    if (params !== undefined) {
      HTTP.post('sort', params).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
        if (e.response.status === 400) {
          callback(e.response)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/products/sorting/index.js